import { defineStore } from 'pinia';

import bff from '@/shared/api/bff';

export const useReinstatementStore = defineStore('reinstatement', {
  actions: {
    async postPolicyReinstatement(payload: { policyNumber: string; reinstatementPayload: object }) {
      try {
        const response = await bff.postPolicyReinstatement(payload);
        if (response.status === 200 || response.status === 201) {
          return response.data?.redirectUrl || '';
        } else {
          throw new Error('Failure with reinstatement submission.');
        }
      } catch (_error) {
        /* empty */
      }
    },
  },
});
